var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    fill: "white",
    viewBox: "0.5 0 24 24",
    enableBackground: "new 0.5 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__konverzni_pomer"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4479",
    x: 1.357,
    y: 3,
    width: 22.285,
    height: 2.571
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4480",
    x: 3.928,
    y: 8.143,
    width: 17.143,
    height: 2.571
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4481",
    x: 7.357,
    y: 13.285,
    width: 10.285,
    height: 2.572
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4482",
    x: 9.5,
    y: 18.429,
    width: 6,
    height: 2.571
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConverse);
export default __webpack_public_path__ + "static/media/converse.6a63f306e23b0e182bd1f5cfd47003a9.svg";
export { ForwardRef as ReactComponent };